module.exports = __webpack_public_path__ + "img/info-setting.f99c35c6.svg";